export default "__VITE_ASSET__B32y$SzG__"